SA.Tags = {
    html(literals, ...substitutions) {
        var html = '';

        for (let i = 0; i < substitutions.length; i++) {
            html += literals[i];
            html += Ext.String.htmlEncode(substitutions[i]);
        }

        html += SA.Array.getLast(literals);

        return html;
    }
};